import { render, staticRenderFns } from "./AdminSetting.vue?vue&type=template&id=6c0c5b3a&scoped=true&"
import script from "./AdminSetting.vue?vue&type=script&lang=js&"
export * from "./AdminSetting.vue?vue&type=script&lang=js&"
import style0 from "./AdminSetting.vue?vue&type=style&index=0&id=6c0c5b3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0c5b3a",
  null
  
)

export default component.exports